<template>
  <div class="profile-info">
    <div class="desktop-inline">
      <div class="item">
        <h4 class="label">Ime</h4>
        <p class="value">{{ name || '...' }}</p>
      </div>
      <div class="item">
        <h4 class="label">Prezime</h4>
        <p class="value">{{ surname || '...' }}</p>
      </div>
    </div>
    <div class="desktop-inline">
      <div class="item">
        <h4 class="label">Adresa e-pošte</h4>
        <p class="value">{{ email || '...' }}</p>
      </div>
      <div class="item last">
        <h4 class="label">Lozinka</h4>
        <p class="value password" @click="openModal">
          <template v-if="wasChangeSuccessful">Lozinka je uspješno promijenjena.</template>
          <template v-else>Promijeni lozinku</template>
        </p>
      </div>
    </div>
    <ChangePasswordModal v-show="isModalActive" @close="closeModal" />
  </div>
</template>

<script>
import ChangePasswordModal from './ChangePasswordModal';

export default {
  name: 'ProfileInfo',
  components: {
    ChangePasswordModal,
  },
  props: {
    name: String,
    surname: String,
    email: String,
  },
  data() {
    return {
      isModalActive: false,
      wasChangeSuccessful: false,
    };
  },
  methods: {
    openModal: function() {
      document.body.classList.add('modal-open');
      this.isModalActive = true;
    },
    closeModal: function(wasSuccessful) {
      document.body.classList.remove('modal-open');
      this.isModalActive = false;

      if (wasSuccessful) {
        this.wasChangeSuccessful = true;
        setTimeout(() => (this.wasChangeSuccessful = false), 5000);
      }
    },
  },
};
</script>

<style scoped>
.profile-info {
  margin-bottom: 64px;
}

.item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.8);
}

.item:not(.last) {
  margin-bottom: 32px;
}

.label {
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  margin-top: 0;
  margin-bottom: 8px;
}

.value {
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  margin-top: 0;
  margin-bottom: 8px;
}

.password {
  color: #30cec2;
  cursor: pointer;
  transition: color 0.2s ease-in-out;
}

.password:hover {
  color: #35e5d8;
}

@media screen and (min-width: 1023px) {
  .desktop-inline {
    display: flex;
    margin-bottom: 48px;
  }

  .item {
    width: 310px;
    margin-right: 110px;
  }

  .item:not(.last) {
    margin-bottom: 0;
  }

  .label {
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 0;
  }
}
</style>
